
<template>
  <div>
    <p v-if="showTitle" class="title">Temperatur</p>
    <vue-c3 :handler="chart"></vue-c3>
  </div>
</template>

<script>
import Vue from "vue";
import VueC3 from "vue-c3";

export default {
  props: {
    serverUrl: {
      type: String,
      default: ""
    },
    showTitle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      temp: 0,
      chart: new Vue()
    };
  },
  created() {
    setTimeout(() => {
      this.startMonitor();
    }, 1000);
  },
  mounted() {
    this.initGraph();
  },
  methods: {
    startMonitor() {
      this.$http
        .get(this.serverUrl + "temperatur.php")
        .then(response => {
          if (this.temp != response.data.value) {
            this.temp = response.data.value;
            this.updateGraph();
            this.$emit("valueChanged", this.temp + "°C");
          }
          setTimeout(() => {
            this.startMonitor();
          }, 4000);
        })
        .catch(error => {
          setTimeout(() => {
            this.startMonitor();
          }, 1000);
        });
    },
    initGraph() {
      let options = {
        data: {
          type: "gauge",
          columns: [["usage", 0]],
        },
        color: {
          pattern: ["#3daee9", "#fdbc4b", "#c0392b"],
          threshold: {
            values: [40, 70, 100]
          }
        },
        tooltip: {
          show: false
        },
        legend: {
          hide: true
        }
      };
      this.chart.$emit("init", options);
    },
    updateGraph() {
      let options = {
        columns: [["usage", this.temp]],
        colors: {
          usage: this.usageColor
        }
      };
      this.chart.$emit("dispatch", cart => cart.load(options));
    }
  },
  components: {
    VueC3
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// app/monitor/src/components/MonitorTemperatur.vue